import {
	AfterViewInit,
	Component,
	ElementRef,
	QueryList,
	ViewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundDirective } from 'src/app/directives/page-not-found.directive';

// Service Imports
import { PageNotFoundService } from 'src/app/services/page-not-found.service';

@Component({
	selector: 'app-page-not-found',
	standalone: true,
	imports: [CommonModule, PageNotFoundDirective],
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements AfterViewInit {
	@ViewChildren('errorTextDisplay', { read: ElementRef })
	textareaComp!: QueryList<ElementRef>;

	constructor(private getMsg: PageNotFoundService) {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.getMsg.type_text(this.textareaComp);
	}
}
